import React from 'react';

import { useTheme } from '@chakra-ui/react';
import { addDays, format, formatDistanceStrict, isFuture, isSameDay, parseISO, isBefore, endOfDay } from 'date-fns';
import isAfter from 'date-fns/isAfter';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const DateComp = ({
  date,
  isRelativeDateFormat = true,
  forceRelativeDateFormat = false,
  enableRelativeFormatDistanceColor = true,
  showDateInBrackets = false,
  textComponent = TextBodyMedium,
}) => {
  const TextComponent = textComponent;
  const theme = useTheme();
  const DATE_COLORS = {
    yellow: theme.colors.functional['8C6A00'],
    red: theme.colors.functional.C62C02,
  };

  const todayDate = new Date();

  const dateSupported = typeof date === 'string' ? parseISO(date) : date;
  const dateSupportedEOD = endOfDay(dateSupported);

  const usUpto7DaysFromNow = isFuture(dateSupportedEOD) && isBefore(dateSupportedEOD, addDays(todayDate, 8));

  let color = theme.colors.text.g1;

  if (enableRelativeFormatDistanceColor) {
    if (isSameDay(dateSupportedEOD, todayDate)) {
      color = DATE_COLORS.red;
    } else if (isFuture(dateSupportedEOD) && usUpto7DaysFromNow) {
      color = DATE_COLORS.yellow;
    }
  }

  let dateText = '-';
  if (isRelativeDateFormat && (usUpto7DaysFromNow || forceRelativeDateFormat)) {
    if (isSameDay(dateSupportedEOD, todayDate)) {
      // today
      dateText = 'Today';
    } else if (isSameDay(dateSupportedEOD, addDays(todayDate, 1))) {
      // tomorrow
      dateText = 'Tomorrow';
    } else if (isSameDay(dateSupportedEOD, addDays(todayDate, 7))) {
      // 1 week
      dateText = '1 week to go';
    } else {
      // 3 days, 4 days...

      if (isAfter(dateSupportedEOD, todayDate)) {
        dateText = `${formatDistanceStrict(dateSupportedEOD, todayDate)} to go`;
      } else {
        dateText = `${formatDistanceStrict(dateSupportedEOD, todayDate)} ago`;
      }
    }
  } else {
    dateText = format(dateSupportedEOD, 'MMM d, y');
  }

  return (
    <TextComponent bold={usUpto7DaysFromNow} color={color}>
      {dateText}
      {showDateInBrackets && <> ({format(dateSupportedEOD, 'MMM d')})</>}
    </TextComponent>
  );
};
